export default __webpack_public_path__ + "static/media/ganapathi.d4b10e06.webp";